/* eslint-disable jsx-a11y/anchor-is-valid */

import {
    FC,
    useState,
    useEffect,
    useRef
  } from 'react'

  import { useIntl } from 'react-intl'
  import { useSelector, shallowEqual, useDispatch } from 'react-redux'
  import {
    KTSVG,
    toAbsoluteUrl
  } from '../../../_metronic/helpers'

  import { Modal } from "react-bootstrap";
  import {useNavigate, useLocation} from 'react-router-dom'

  import CreateCreditCard from '../CreditCard/CreateCreditCard';
  import EditDocument from './components/EditDocument';
  import EditProfile from './components/EditProfile';

  import {
    fetchCreditCards,
    fetchDeleteCreditCard,
  } from '../../services/creditCard';

import {
  getMeInfo,
} from '../../services/auth';

import {
  getBrandImage,
} from "../../utils/Labels";

import CancelModal from "../../utils/CancelModal";

import {
  unlinkProvider,
  logout,
} from "app/services/auth";

import {
  requestDeleteAccount,
} from "app/services/profile";
import { formatLongDateTime } from 'app/services/dates';

const Profile = ({isOpen}) => {
  const { auth, profile } = useSelector((state : any) => ({
    auth: state.auth,
    profile: state.profile,
  }), shallowEqual);

  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openDeleteAccount, setOpenDeleteAccount] = useState<any>(false);
  const [openRemovePhone, setOpenRemovePhone] = useState<any>(false);
  const [openEditProfile, setOpenEditProfile] = useState<any>(false);
  const [openDeleteCreditCard, setOpenDeleteCreditCard] = useState<any>(false);
  const [deleteSelectCreditCard, setDeleteSelectCreditCard] = useState<any>(null);
  const [open, setOpen] = useState<any>(false);

//   useEffect(() => {
//     dispatch<any>(fetchCreditCards());
//   }, []);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

//   const verifyOpenCreateCreditCard = () => {
//     dispatch<any>(getMeInfo()).then((data: any) => {
//       if (data && data.attributes && data.attributes.document) {
//         setOpenCreateCreditCard(true);
//       } else {
//         setOpenEditProfile(true);
//       }
//     }).catch(() => {
//       setOpenCreateCreditCard(true);
//     })
//   }

  // const closeCreateCreditCard = () => {
  //   setOpenCreateCreditCard(false);
  // }

  const onClosed = () => {
    setOpen(false);
    navigate(-1);
  }

  const openDeleteCreditCardModal = (value) => {
    setOpenDeleteCreditCard(true);
    setDeleteSelectCreditCard(value);
  }

  const closeDeleteCreditCardModal = () => {
    setOpenDeleteCreditCard(false);
    setDeleteSelectCreditCard(null);
  }

  const dispatchLogout = () => {
    dispatch<any>(logout());

    navigate(-1);
  }

  const removePhone = () => {
    dispatch<any>(unlinkProvider('phone'));
    setOpenRemovePhone(false);
  }

  const deleteAccount = (value: boolean) => {
    dispatch<any>(requestDeleteAccount(value === true ? 1 : 0));
    setOpenDeleteAccount(false);
  }

  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open && !openRemovePhone && !openDeleteAccount && !openEditProfile}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          <Modal.Title id="cancel-schedule-title" className="flex-root d-flex">
            <div className='menu-content d-flex align-items-center px-3'>
              <div className='symbol symbol-50px me-5'>
                <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
              </div>

              <div className='d-flex flex-column'>
                <div className='fw-bolder d-flex align-items-center fs-5'>
                  {auth.user?.name}
                  <span
                  className='cursor-pointer badge badge-light-primary fw-bolder fs-8 px-2 py-1 ms-4'
                  onClick={() => setOpenEditProfile(true)}
                  >
                    Alterar
                  </span>
                </div>
                <span className='fw-bold text-muted fs-7'>
                  {auth.user?.email}
                </span>
              </div>
            </div>
          </Modal.Title>

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-auto min-w-320px mw-400px w-100 pt-0 mb-5">
            <div className="fv-row mb-5">
              <span
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3`}
                onClick={() => navigate({}, { state: { creditCards: location } })}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                    <i className="las la-credit-card fs-2x text-white"></i>
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Meus cartões</span>
                  </span>
                </span>
              </span>
            </div>

            {auth.user?.phone && <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed border-gray-300 d-flex text-start p-5 mb-3 cursor-default`}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="pt-3 mr-2 text-right">
                    <img
                      src={toAbsoluteUrl(`/media/custom/whatsapp.png`)}
                      height="24"
                      width="24"
                      alt='Estacionamento'
                      className="icon-flag text-hover-primary"
                    />
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Telefone</span>
                    <span className="fw-semibold fs-6 text-muted">{auth.user?.phone}</span>
                  </span>
                  <span className="ms-4 text-right">
                    <span
                      id="create-credit-card-span"
                      className="btn btn-xs fw-light btn-secondary btn-active-light-primary w-100"
                      onClick={() => setOpenRemovePhone(true)}
                    >
                      <span className="indicator-label">Excluir telefone</span>
                    </span>
                  </span>

                </span>
              </label>
            </div>}

            {!auth.user?.phone && <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3`}
                onClick={() => navigate({}, { state: { verifyPhoneUrl: location } })}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                    <img
                      src={toAbsoluteUrl(`/media/custom/whatsapp.png`)}
                      height="24"
                      width="24"
                      alt='Estacionamento'
                      className="icon-flag text-hover-primary"
                    />
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Validar telefone</span>
                  </span>
                </span>
              </label>
            </div>}

            <div className="fv-row mb-5">
              <a
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3`}
                href="https://atacante.app/termos-de-uso.html"
                target='_blank' rel="noreferrer"
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                    <i className="las la-book fs-2x text-white"></i>
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Termos de uso</span>
                  </span>
                </span>
              </a>
            </div>

            <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start p-5 mb-3`}
                onClick={() => dispatchLogout()}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                  <i className="las la-sign-out-alt fs-2x text-white"></i>
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Sair</span>
                  </span>
                </span>
              </label>
            </div>

            <div className='separator my-5'></div>

            {!auth.user?.date_expire && <div className="fv-row mb-5">
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-danger border-gray-300 d-flex text-start p-5 mb-3`}
                onClick={() => setOpenDeleteAccount(true)}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                    <i className="las la-trash fs-2x text-danger"></i>
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Excluir minha conta</span>
                  </span>
                </span>
              </label>
            </div>}

            {auth.user?.date_expire && <div className="fv-row mb-5">
              <span className='text-gray-600 fs-6'>
                Exclusão da conta foi solicitada e será atendida até {formatLongDateTime(auth.user?.date_expire, true)}
              </span>
              <label
                className={`btn btn-outline btn-outline-dashed btn-active-light-primary border-gray-300 d-flex text-start p-5 my-3`}
                onClick={() => deleteAccount(false)}
              >
                <span className="flex-root d-flex flex-row justify-content-betweeen">
                  <span className="mr-2 text-right">
                    <i className="las la-trash fs-2x text-danger"></i>
                  </span>
                  <span className="flex-root d-flex flex-column ms-4">
                    <span className="fs-5 fw-bold text-gray-900 mb-1 d-block">Cancelar solicitação</span>
                  </span>
                </span>
              </label>
            </div>}
          </div>
        </Modal.Body>
      </Modal>


      <EditProfile
        isOpen={openEditProfile}
        onClosed={() => setOpenEditProfile(false)}
      />

      {/* <CreateCreditCard
        isOpen={openCreateCreditCard}
        onClosed={() => closeCreateCreditCard()}
      />

      <CancelModal
        isOpen={openDeleteCreditCard}
        onClosed={closeDeleteCreditCardModal}
        title="Excluir cartão"
        text="Seu cartão será excluído, você pode cadastrar-lo novamente"
        button="excluir cartão"
        onChange={() => deleteCreditCard()}
        isLoading={creditCards.actionsLoading === true}
      /> */}

      <CancelModal
        isOpen={openRemovePhone}
        onClosed={() => setOpenRemovePhone(false)}
        title="Excluir telefone?"
        text={<span className='text-gray-600 fw-light'>
          Seu telefone será excluido da sua conta<br />
          Você vai precisar adicionar outro telefone ou válidar novamente no mesmo telefone
        </span>}
        button="Remover telefone"
        onChange={() => removePhone()}
        isLoading={auth.actionsLoading === true}
      />

      <CancelModal
        isOpen={openDeleteAccount}
        onClosed={() => setOpenDeleteAccount(false)}
        title={<span className='text-uppercase'>você tem certeza?</span>}
        text={<span className='text-gray-600 fw-light'>
          Lamentamos muito você ter tomado essa decisão, esperamos que volte em breve a jogar conosco!<br />
          O prazo para exclusão dos seus dados são de <span className='text-gray-900'>até 72 horas</span>, nesse período você desistir da exclusão.
        </span>}
        button="SOLICITAR EXCLUSÃO"
        onChange={() => deleteAccount(true)}
        isLoading={profile.actionsLoading === true}
      />
    </>
  )
}

export default Profile;
